import WhyMePage from './whyMePage.component';

export default WhyMePage;